import { Mm100Page } from '@/components/calculators/power-kits';
import Image from '@/components/UI/Image';
import FixedCalculatorFooter from '@/componentsH5/calculators/components/FixedCalculatorFooter';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
const scenes = [
    { key: 'rv', img: '/img/calculators/mm100H5/step1-rv.jpg', i18n: 'rv' },
    { key: 'house', img: '/img/calculators/mm100H5/step1-offGrid.jpg', i18n: 'house' },
    { key: 'others', img: '/img/calculators/mm100H5/step1-others.jpg', i18n: 'others' },
];

export default function Step1H5({ data, callBack }: any) {
    const { useLang, useState, useEffect, gtm } = useGlobal();
    const { t } = useLang('shared');
    const [active, setActive] = useState(data?.scene || '');

    useEffect(() => {
        setActive(data?.scene);
    }, [data?.scene]);

    const chooseScene = (key: string) => {
        if (key !== active) {
            if (key === 'others') {
                callBack({ scene: key, totalStep: 6, stepTitle: [key, ...data.stepTitle.slice(2)] });
            } else {
                callBack({
                    scene: key,
                    totalStep: 7,
                    stepTitle: [key, 'type', ...data.stepTitle.slice(-5)],
                });
            }
            setActive(key);
        }
    };

    const onNext = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'calculator1',
            step: 'solution',
            product_name: 'Ecoflow Power Kits',
            option_name: active,
            button_name: 'Next',
        });
        callBack({
            scene: active,
            currentStep: data.currentStep + 1,
            currentPage: active === 'others' ? Mm100Page.Appliances : Mm100Page.Type,
        });
    };

    return (
        <div className={`step1H5 ${css.step1H5}`}>
            <h2 className="step1-title">{t('calculators.mm100.step1.title')}</h2>
            <ul className="step1-scenes">
                {scenes?.map((scene: any) => (
                    <li className={`step1-scene ${active === scene.key ? 'active' : ''}`} key={scene.key} onClick={() => chooseScene(scene.key)}>
                        <div className="img-item">
                            <Image
                                src={scene?.img}
                                layout="fill"
                                className="fullImgs"
                                alt={t(`calculators.mm100.step1.${scene.i18n}`)}
                                aria-label={t(`calculators.mm100.step1.${scene.i18n}`)}
                            />
                        </div>
                        <div className="cover"></div>
                        {active === scene.key && (
                            <div className="checkIcon">
                                <Image
                                    src="/img/calculators/mm100/selected.svg"
                                    layout="fill"
                                    className="fullImgs"
                                    alt={t(`calculators.mm100.step1.${scene.i18n}`)}
                                    aria-label={t(`calculators.mm100.step1.${scene.i18n}`)}
                                />
                            </div>
                        )}
                        <p className="sceneTitle">{t(`calculators.mm100.step1.${scene.i18n}`)}</p>
                    </li>
                ))}
            </ul>
            <FixedCalculatorFooter>
                <button
                    className={`step1H5-nextBtn commonNext ${active ? 'active' : ''}`}
                    onClick={onNext}
                    disabled={!active}
                    aria-label={t('calculators.mm100.next')}
                >
                    {t('calculators.mm100.next')}
                </button>
            </FixedCalculatorFooter>
        </div>
    );
}
